import { createSelector } from 'reselect'

import { isAvailableFeatureSelector } from 'features/billing'
import FeatureFlags from 'services/feature_flags'

import { STATUS_LOADING, STATUS_INITIAL, FEATURE_ACTIVITY_LOG_ACCESS_KEY } from './constants'

const activityLogSliceSelector = ({ activityLog }) => activityLog
const billingSliceSelector = ({ billing }) => billing
const segmentSliceSelector = ({ segment }) => segment

export const exportPopupToRenderSelector = createSelector(activityLogSliceSelector, ({ exportPopupToRender }) => exportPopupToRender)

export const activityLogCollectionSelector = createSelector(
  activityLogSliceSelector,
  ({ collection }) => collection
)

export const activityLogPaginationSelector = createSelector(
  activityLogSliceSelector,
  ({ pagination }) => pagination
)

export const isLoadingSelector = createSelector(
  activityLogSliceSelector,
  ({ status }) => status === STATUS_LOADING || status === STATUS_INITIAL
)

export const activityLogCountSelector = createSelector(
  activityLogSliceSelector,
  ({ totalCount, exceedsMaxTotalCount }) => ({ totalCount, exceedsMaxTotalCount })
)

export const sortOrderSelector = createSelector(
  activityLogSliceSelector,
  ({ sortOrder }) => sortOrder
)

export const sortFieldSelector = createSelector(
  activityLogSliceSelector,
  ({ sortField }) => sortField
)

export const pageNumberSelector = createSelector(
  activityLogSliceSelector,
  ({ pageNumber }) => pageNumber
)

export const pageSizeSelector = createSelector(
  activityLogSliceSelector,
  ({ pageSize }) => pageSize
)

export const filtersSelector = createSelector(
  activityLogSliceSelector,
  ({ filters }) => filters
)

export const showFilterBarSelector = createSelector(
  activityLogSliceSelector,
  ({ showFilterBar }) => showFilterBar
)

export const pageTokenSelector = createSelector(
  activityLogSliceSelector,
  ({ pageToken }) => pageToken
)

export const selectedAggregationsSelector = (aggregationKey) => createSelector(
  activityLogSliceSelector,
  ({ filters }) => filters[aggregationKey] || []
)

export const aggregationOptionsSelector = (aggregationKey) => createSelector(
  activityLogSliceSelector,
  ({ aggregations }) => aggregations[aggregationKey] || {}
)

export const selectedPeriodSelector = createSelector(
  activityLogSliceSelector,
  ({ selectedPeriod }) => selectedPeriod
)

export const isActivityLogFeatureEnabledSelector = createSelector(
  (state) => isAvailableFeatureSelector(state, { featureKey: FEATURE_ACTIVITY_LOG_ACCESS_KEY }),
  (isAvailableFeature) => FeatureFlags[FEATURE_ACTIVITY_LOG_ACCESS_KEY] || isAvailableFeature
)

const billingOrgSelector = createSelector(
  billingSliceSelector,
  (billing) => billing.currentSubscription.organization
)
export const currentBillingPlanSelector = createSelector(
  billingOrgSelector, (billingOrg) => `${billingOrg.stage}:${billingOrg.tier}`
)

export const calendlySegmentOrgIdSelector = createSelector(
  segmentSliceSelector,
  (segment) => segment.identify_options[1].calendly_organization_id
)

export const searchTermSelector = createSelector(
  activityLogSliceSelector,
  ({ searchTerm }) => searchTerm
)
